
import { Ticket } from "@/models/ticket";
import Vue from "vue";
export default Vue.extend({
	data(){
		return {
			images: [] as string[],
			other: [] as string[],
			confirmed: false
		};
	},
	props: {
		files: {
			type: Array as ()=>File[],
			default(){
				return [];
			}
		},
		ticket: {
			type: Object as ()=>Ticket,
			required: true
		}
	},
	watch: {
		files: {
			immediate: true,
			handler(){
				for (let img of this.images){
					URL.revokeObjectURL(img);
				}
				for (let file of this.files){
					console.log(file.type);
					if (file.type.toLowerCase().indexOf("image") != -1){
						this.images.push(URL.createObjectURL(file));
					}else{
						this.other.push(file.name);
					}
				}
			}
		}
	},
	methods: {
		cancel(){
			for (let i = this.files.length -1; i >= 0; i--) {
				this.files.splice(i,1);
			}
		},
		confirm(){
			if (this.confirmed) return;
			this.$emit("send-files", this.files);
			this.confirmed = true;

		}
	},
	destroyed(){
		for (let img of this.images){
			URL.revokeObjectURL(img);
		}
	}
});
